import React from "react";
import { withRouter } from "react-router";
// eslint-disable-next-line import/no-restricted-paths
import Sidebar from "../../_legacy/Containers/Settings/sidebar";
import PosTitle from "../../Components/Settings/Pos/PosTitle";

const LayoutPosSettings = ({ history, activeMenu, children }) => {
  const languageData = JSON.parse(localStorage.getItem("languageData"));

  return (
    <div className="main protected">
      <div id="content" className="content-pos-dashboard">
        <div className="container-fluid content setting-wrapper">
          <Sidebar />
          <div className="business-setion memberWalletOuter flex-col">
            <PosTitle
              history={history}
              settingsLang={languageData.settings}
              globalLang={languageData.global}
              activeMenu={activeMenu}
            />
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(LayoutPosSettings);
